//https://nio.feishu.cn/wiki/EDOjwPaCjib1gJku0EicOuFmnkh
import Tracker from '@nio-fe/tracker-sdk';
// import SensorsTracker from '@nio-fe/nio-tracker-web';
import { omit, uniq } from 'lodash-es';

export const getDefaultTrackerProfile = () => {
  return {};
};

// const initSensorsTracker = (
//   account: {
//     accountId: string;
//     domainAccount?: string;
//     env: string;
//     email?: string;
//     appId: string;
//   },
//   organizations: any[] = [],
//   brands: string[]
// ) => {
//   const { appId = '100498', accountId, domainAccount, env, email } = account;
//   const isProd = env === 'prod';
//   const project = isProd ? 'nio_business_prod' : 'nio_business_test';
//   const emailDomain = (email || '').split('@')[0];
//   const show_log = !isProd;
//   /**
//    * 埋点初始化
//    * @param {object} options - 公共属性
//    * @param {object} initConfig - 初始配置项
//    */
//   SensorsTracker.init(
//     {
//       appId,
//       workerUserId: domainAccount || emailDomain,
//       platform_version: 'Mate',
//       mp_id: 'com.nio.titan',
//       brand: brands.join(','),
//       position_code: uniq(organizations.map((item) => item.positionCode)).join(
//         ','
//       ),
//       position_name: uniq(organizations.map((item) => item.positionName)).join(
//         ','
//       ),
//     },
//     {
//       project, // 默认为 nio_event_tracking
//       show_log,
//     }
//   );
//   SensorsTracker.getInstance().login(accountId);
// };

const initNioTracker = (
  account,
  organizations: any[] = [],
  brands: string[] = []
) => {
  const { accountId, domainAccount, env, email } = account;
  const isProd = env === 'prod' ? true : false;
  const project = isProd ? 'nio_business_prod' : 'nio_business_test';
  const emailDomain = (email || '').split('@')[0];

  /**
   * 埋点初始化
   * @param {object} options - 公共属性
   * @param {object} initConfig - 初始配置项
   */
  Tracker.init({
    project,
    show_log: !isProd,
    send_type: 'image',
    app_js_bridge: false,
    is_track_single_page: true,
    heatmap: {
      clickmap: 'default',
      scroll_notice_map: 'not_collect',
    },
    // 不用双报了，传什么都是一个路径
    report_source: null,
  });
  // workerUserId: domainAccount || emailDomain,
  Tracker.login(accountId);
  Tracker.use('PageLeave', {
    heartbeat_interval_time: 5, // 心跳间隔
    max_duration: 24 * 60 * 60,
    isCollectUrl: (url: string) => true, // 是否收集页面URL
  });
  Tracker.registerPage({
    workerUserId: domainAccount || emailDomain,
    nio_worker_user_id: domainAccount || emailDomain,
    brand: brands.join(','),
    platform_version: 'Mate',
    mp_id: 'com.nio.titan',
    position_code: uniq(organizations.map((item) => item.positionCode)).join(
      ','
    ),
    position_name: uniq(organizations.map((item) => item.positionName)).join(
      ','
    ),
  });
};

export default (account: any, organizations: any[], brands: string[]) => {
  initNioTracker(account, organizations, brands);
  // initSensorsTracker(account, organizations, brands);
  return {
    install(vue) {
      vue.directive('s-clk', {
        created(el, binding) {
          el.addEventListener(
            'click',
            () => {
              console.log(
                '%c[埋点]',
                'color:#3b92de',
                '点击',
                binding.arg,
                binding.value
              );
              Tracker.track(binding.arg, {
                ...binding.value,
              });
            },
            true
          );
        },
      });

      vue.directive('tit-tracker', {
        created(el, { arg, value }) {
          let eventName;
          let realEl = el;
          const handler = (evt?) => {
            console.log(evt, '%c[埋点]', 'color:#3b92de', eventName, value);
            Tracker.track(value.trackName, {
              ...omit(value, 'trackName'),
            });
          };
          const exposeFunc = () => {
            eventName = 'expose';
            const observer = new IntersectionObserver(
              ([{ isIntersecting }]) => {
                if (isIntersecting) {
                  /*only trigger once*/
                  handler();
                  observer.unobserve(el);
                }
              }
            );
            observer.observe(el);
          };
          switch (arg) {
            case 'click':
              eventName = 'click';
              break;
            case 'expose':
              exposeFunc();
              return;
              break;
            case 'input':
              if (realEl.tagName.toLowerCase() !== 'input') {
                realEl = realEl.querySelector('input');
              }
              eventName = 'input';
              break;
            case 'blur':
              if (realEl.tagName.toLowerCase() !== 'input') {
                realEl = realEl.querySelector('input');
              }
              eventName = 'blur';
              break;
            case 'hover':
              eventName = 'mouseEnter';
              break;
          }

          realEl.addEventListener(eventName, handler);
        },
        unbind() {
          // realEl.removeEventListener(eventName, handler);
        },
      });

      vue.provide('$sensors', Tracker);
    },
  };
};
